"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ClassroomsModel = /** @class */ (function () {
    function ClassroomsModel($http, APPURL) {
        this.$http = $http;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: APPURL + "/api/v1/classrooms",
            UPDATE: APPURL + "/api/v1/classrooms",
            CREATE: APPURL + "/api/v1/classrooms",
        };
        this.data = [];
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
    }
    ClassroomsModel.prototype.extract = function (result) {
        return result.data;
    };
    ClassroomsModel.prototype.cacheResults = function (result) {
        return this.extract(result);
    };
    ClassroomsModel.prototype.show = function (id) {
        return this.$http
            .get(this.URLS.FETCH + "/" + id)
            .then(this.cacheResults);
    };
    ClassroomsModel.prototype.get = function () {
        return this.$http
            .get(this.URLS.FETCH)
            .then(this.cacheResults);
    };
    ClassroomsModel.prototype.update = function (request) {
        return this.$http
            .put(this.URLS.FETCH + "/" + request.id, request)
            .then(this.cacheResults);
    };
    ClassroomsModel.prototype.create = function (request) {
        return this.$http
            .post(this.URLS.FETCH, request)
            .then(this.cacheResults);
    };
    ClassroomsModel.prototype.delete = function (data) {
        return this.$http
            .delete(this.URLS.FETCH + "/" + data.id)
            .then(this.cacheResults);
    };
    ClassroomsModel.prototype.search = function (params) {
        if (params.location) {
            if (params.location.zones) {
                delete params.location.zones;
            }
            if (params.location.zoneparts) {
                delete params.location.zoneparts;
            }
        }
        return this.$http
            .post(this.URLS.FETCH + "/search", params)
            .then(this.cacheResults);
    };
    return ClassroomsModel;
}());
ClassroomsModel.$inject = ["$http", "APPURL"];
exports.default = ClassroomsModel;
